/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HistoricalDriverEarningPreviewAdminDto } from '../models/HistoricalDriverEarningPreviewAdminDto';
import type { PostHistoricalDriverEarningPreviewAdminRequest } from '../models/PostHistoricalDriverEarningPreviewAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HistoricalDriverEarningsReconstructionService {
    /**
     * **Required Policy:** `ViewDriverEarning`
     * @returns HistoricalDriverEarningPreviewAdminDto OK
     * @throws ApiError
     */
    public static previewAdmin({
        requestBody,
    }: {
        requestBody?: PostHistoricalDriverEarningPreviewAdminRequest,
    }): CancelablePromise<HistoricalDriverEarningPreviewAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driver-earnings/reconstruction/preview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
